<div class="header-container">
  <app-breadcrumb></app-breadcrumb>
  <button mat-icon-button class="close-button" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-card>
  <mat-card-content>
    @if (!procedure && !readOnly) {
      <h1 class="title">Ajouter une procédure</h1>
    } @else if (procedure && !readOnly) {
      <h1 class="title">Modifier une procédure</h1>
    } @else {
      <h1 class="title">Consulter une procédure</h1>
    }

    <form [formGroup]="procedureForm" (ngSubmit)="onSubmit(EtatEnum.EN_APPLICATION)" style="padding: 16px">

      <div class="statut">
        @if (procedure) {
          <span [ngClass]="{
            'status-bubble': true,
            'en-application': procedure.etat.libelle === 'En application',
            'archive': procedure.etat.libelle === 'Archivé',
            'en-attente': procedure.etat.libelle === 'En attente d\'activation'
          }">
            {{ procedure.etat.libelle }}
          </span>
        }

        <ng-container>
          @if (!procedure) {
              <button type="button" (click)="createOrUpdateLogigramme()" class="keolis-primary-button " color="primary" mat-raised-button aria-label="Ouvrir modal jointjs">
                <mat-icon>add</mat-icon>
                Créer un logigramme
              </button>
          }

          @if(procedure) {
            <div style="margin-left: auto; display: flex">
              @if (procedure.logigramme && Object.keys(procedure.logigramme).length > 0 && procedure.logigramme.cells && procedure.logigramme.cells.length > 0) {
                <button type="button" (click)="openReadOnlyLogigrammeDialog()" class="keolis-primary-button " color="primary" mat-raised-button aria-label="Ouvrir modal jointjs">
                  <mat-icon>brush</mat-icon>
                  Visualiser le logigramme
                </button>
              }
            </div>
            @if (isAdmin && !readOnly) {
              <button type="button" style="margin-left: 1rem" (click)="createOrUpdateLogigramme()" class="keolis-primary-button " color="primary" mat-raised-button aria-label="Ouvrir modal jointjs">
                <mat-icon>edit</mat-icon>
                Modifier le logigramme
              </button>
            }

          }
        </ng-container>
      </div>


      <div class="form-row" style="max-width: 50%">
        <mat-form-field class="form-element" appearance="outline">
          <mat-label>Type</mat-label>
          <mat-select formControlName="type" required (selectionChange)="onTypeSelect($event)"
                      [disabled]="procedure || readOnly">
            <mat-option *ngFor="let type of types" [value]="type.id" [disabled]="procedure">{{ type.libelle }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="select-group">
        <p >Procédure de sécurité : </p>
        <mat-button-toggle-group
          name="fontStyle"
          aria-label="Font Style"
          formControlName="isSecurite"
          class="toggle-group"
          >
          <mat-button-toggle value="oui" [class.selected-yes]="procedureForm.get('isSecurite')?.value === 'oui'">Oui</mat-button-toggle>
          <mat-button-toggle value="non" [class.selected-no]="procedureForm.get('isSecurite')?.value === 'non'">Non</mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      <div class="form-row">
        <mat-form-field *ngIf="!isProcedureInit()" class="form-element" appearance="outline">
          <mat-label>Mnémonique de la procédure de référence</mat-label>
          <input
            formControlName="mnemoniqueRef"
            matInput
            [required]="!isProcedureInit()"
            placeholder="Saisir un mnemonique"
            [matAutocomplete]="autoMnemoniqueRef"
            (blur)="onMnemoniqueBlurRef()"
            [readonly]="readOnly || isEnApplication"
          >
          <mat-autocomplete
            #autoMnemoniqueRef="matAutocomplete"
            (optionSelected)="getProcedureInfos($event)"
          >
            <mat-option
              *ngFor="let procedure of filteredProceduresMnemoniqueRef | async"
              [value]="procedure.mnemonique"
              (select)=getProcedureInfos($event)
            >
              {{ procedure.mnemonique }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="procedureForm.get('mnemoniqueRef')!.hasError('required')">Le mnémonique est obligatoire
          </mat-error>
          <mat-error *ngIf="procedureForm.get('mnemoniqueRef')!.hasError('mnemoniqueNotExists')">Ce mnémonique n'existe
            pas
          </mat-error>
        </mat-form-field>

        <mat-form-field class="form-element" appearance="outline">
          <mat-label>Mnémonique de la procédure</mat-label>
          <input
            formControlName="mnemonique"
            matInput
            required
            placeholder="Saisir un mnemonique"
            [matAutocomplete]="autoMnemonique"
            (blur)="onMnemoniqueBlur()"
            [readonly]="mnemoniqueDisabled() || readOnly || isEnApplication"
          >
          <mat-autocomplete #autoMnemonique="matAutocomplete">
            <mat-option
              *ngFor="let procedure of filteredProceduresMnemonique | async"
              [value]="procedure.mnemonique"
              [disabled]="mnemoniqueDisabled()"
            >
              {{ procedure.mnemonique }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="procedureForm.get('mnemonique')!.hasError('required')">Le méemonique est obligatoire</mat-error>
          <mat-error *ngIf="procedureForm.get('mnemonique')!.hasError('mnemoniqueExists')">Le mnémonique existe déjà</mat-error>
        </mat-form-field>
      </div>

      <div class="form-row" style="max-width: 50%">
        <mat-form-field class="form-element" appearance="outline">
          <mat-label>Réference</mat-label>
          <input formControlName="reference" matInput required placeholder="Saisir la réference de la procédure"
                 [readonly]="readOnly">
        </mat-form-field>
      </div>

      <div class="form-row" style="max-width: 50%">
        <mat-form-field class="form-element" appearance="outline">
          <mat-label>Titre de la procédure</mat-label>
          <input
            formControlName="titre"
            matInput
            required
            placeholder="Saisir le titre de la procédure"
            [matAutocomplete]="autoTitre"
            (blur)="onTitreBlur()"
            [readonly]="readOnly"
            >
            <mat-autocomplete #autoTitre="matAutocomplete">
              <mat-option
                *ngFor="let procedure of filteredProceduresTitre | async"
                [value]="procedure.titre"
              >
                {{ procedure.titre }}
              </mat-option>
            </mat-autocomplete>
          <mat-error *ngIf="procedureForm.get('titre')!.hasError('required')">Le titre est obligatoire</mat-error>
          <mat-error *ngIf="procedureForm.get('titre')!.hasError('titreExists')">Le titre existe déjà</mat-error>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field class="form-element" appearance="outline">
          <mat-label>Groupe Diffusion</mat-label>
          <input matInput formControlName="groupeDiffusion" [matAutocomplete]="autoGroup"
                 placeholder="Rechercher un groupe">
          <mat-autocomplete #autoGroup="matAutocomplete" (optionSelected)="onGroupSelected($event)">
            @for (group of filteredGroupes | async; track group) {
              <mat-option [value]="group">
                {{ group.titre }}
              </mat-option>
            }
          </mat-autocomplete>
          @if (procedureForm.get('groupeDiffusion')!.hasError('required')) {
            <mat-error>
              Veuillez sélectionner au moins un groupe de diffusion.
            </mat-error>
          }
        </mat-form-field>

        @if (selectedGroups.length > 0) {
          <div class="groupes-selectionnes">
            <h3>Groupes sélectionnés :</h3>
            <ul>
              @for (group of selectedGroups; track group) {
                <li class="element-liste">
                  {{ group.titre }}
                  @if (!readOnly) {
                    <button mat-icon-button (click)="onRemoveGroup(group)" aria-label="Supprimer le groupe">
                      <mat-icon>delete</mat-icon>
                    </button>
                  }
                </li>
              }
            </ul>
          </div>
          <mat-divider></mat-divider>
        }
      </div>


      <div class="form-row">
        <mat-form-field class="form-element" appearance="outline">
          <mat-label>Catégorie</mat-label>
          <mat-select formControlName="category" required>
            <mat-option *ngFor="let category of categories" [value]="category.id"
                        [disabled]="readOnly">{{ category.libelle }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="form-element" appearance="outline">
          <mat-label>Mode</mat-label>
          <mat-select formControlName="mode" required>
            <mat-option *ngFor="let mode of modes" [value]="mode.id" [disabled]="readOnly">{{ mode.libelle }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="form-element" appearance="outline">
          <mat-label>Lieu d'utilisation</mat-label>
          <mat-select formControlName="perimetre" required>
            <mat-option *ngFor="let perimetre of perimetres" [value]="perimetre.id"
                        [disabled]="readOnly">{{ perimetre.libelle }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field class="form-element" appearance="outline">
          <mat-label>Version</mat-label>
          <input type="number" formControlName="version" matInput min="0" required>
        </mat-form-field>
        <mat-form-field class="form-element" appearance="outline">
          <mat-label>Tags/Mots clés</mat-label>
          <mat-chip-grid #reactiveChipGrid aria-label="Enter reactive form keywords" formControlName="tags">
            @for (tag of tags.controls; track tag) {
              <mat-chip-row (removed)="removeTag(tag.value)" [disabled]="readOnly">
                {{ tag.value }}
                @if (!readOnly) {
                  <button matChipRemove aria-label="'remove reactive form' + keyword">
                    <mat-icon>cancel</mat-icon>
                  </button>
                }
              </mat-chip-row>
            }
          </mat-chip-grid>
          <input
            placeholder="Saisir un tag..."
            [matChipInputFor]="reactiveChipGrid"
            (matChipInputTokenEnd)="addTag($event)"
            [readonly]="readOnly"
          />
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field class="form-element" appearance="outline">
          <mat-label>Contexte</mat-label>
          <textarea formControlName="contexte" matInput placeholder="Saisir le contexte de la procédure"
                    [readonly]="readOnly"></textarea>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field class="form-element" appearance="outline">
          <mat-label>Commentaire</mat-label>
          <textarea formControlName="commentaire" matInput placeholder="Saisir un commentaire"
                    [readonly]="readOnly"></textarea>
        </mat-form-field>
      </div>

      <div class="form-row" *ngIf="!isProcedureInit()">
        <mat-form-field class="form-element" [class.error]="procedureForm.errors?.['dateRangeInvalid']"
                        appearance="outline">
          <mat-label>Début de validité</mat-label>
          <input matInput [matDatepicker]="startDatePicker" [required]="!isProcedureInit()"
                 formControlName="dateDebutValidite" [readonly]="readOnly">
          <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="form-element" [class.error]="procedureForm.errors?.['dateRangeInvalid']"
                        appearance="outline">
          <mat-label>Fin de validité</mat-label>
          <input matInput [matDatepicker]="endDatePicker" [required]="!isProcedureInit()"
                 formControlName="dateFinValidite" [matDatepickerFilter]="dateFinValiditeFilter" [readonly]="readOnly">
          <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field>
        <div class="error-container">
          <div *ngIf="procedureForm.errors?.['dateRangeInvalid']">
            <mat-error>La date de fin de validité doit être supérieure à la date de début de validité.</mat-error>
          </div>
        </div>
      </div>

      @if ((procedure && procedure.annexes && procedure.annexes.length > 0)) {
        <div class="form-row" style="padding: 12px">
          <h4>Annexes</h4>
          @for (annexe of procedure.annexes; track annexe) {
            <div class="annexe">
              @if (isAdmin) {
                <a href="{{ annexe.docLink }}" target="_blank">{{ annexe.fileName }}</a>
                @if (!readOnly) {
                  <button mat-icon-button (click)="deleteAnnexe(annexe)">
                    <mat-icon>delete</mat-icon>
                  </button>
                }
              } @else {
                <span>{{ annexe.fileName }}</span>
              }
              <button mat-icon-button type="button" (click)="openDocumentViewDialog(annexe)">
                <mat-icon>visibility</mat-icon>
              </button>
            </div>
          }
        </div>
      }

      @if ((procedureReference && procedureReference.annexes && procedureReference.annexes.length > 0)) {
        <div class="form-row" style="padding: 12px">
          <h4>Annexes</h4>
          @for (annexe of procedureReference.annexes; track annexe) {
            <div class="annexe">
              <a href="{{ annexe.docLink }}" target="_blank">{{ annexe.fileName }}</a>
              <button mat-icon-button (click)="deleteAnnexe(annexe)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          }
        </div>
      }

      @if (!readOnly) {
        <app-file-upload-dnd (filesUploaded)="handleFilesUploaded($event)"></app-file-upload-dnd>
      }

      <div *ngIf="emargementData?.showEmargement && !emargementDone" class="emargement-block" [formGroup]="emargementForm">
        <p>Veuillez confirmer que vous avez bien pris connaissance de la procédure :</p>
        <mat-checkbox formControlName="emargementConfirmed">
          Je confirme avoir visualisé et lu la procédure
        </mat-checkbox>
        <button
          mat-raised-button
          color="primary"
          [disabled]="!emargementForm.get('emargementConfirmed')?.value"
          (click)="onValidateEmargement()"
        >
          Valider
        </button>
      </div>

      <div *ngIf="emargementDone" class="emargement-success">
        ✅ Emargement effectué  
      </div>

      @if (!procedure) {
        <div class="button-row">
          <button mat-stroked-button (click)="onCancel()">Retour</button>
          <button mat-stroked-button color="warn" [disabled]="!validFrom()"
                  (click)="$event.preventDefault();onSubmit(EtatEnum.EN_ATTENTE)">Mettre en attente d'activation
          </button>
          <button mat-stroked-button color="primary" [disabled]="!procedureForm.valid" type="submit">Valider</button>
        </div>
      } @else {
        <div class="button-row">
          <button mat-stroked-button (click)="onCancel()">Retour</button>
          @if (!readOnly) {
            @if (currentEtat == EtatEnum.EN_ATTENTE) {
              <button mat-stroked-button color="warn" (click)="$event.preventDefault();openDeleteDialog(procedure.id)">
                Supprimer
              </button>
              <button mat-stroked-button color="warn" [disabled]="!procedureForm.valid"
                      (click)="$event.preventDefault();onSubmit(EtatEnum.EN_ATTENTE)">Enregistrer
              </button>
              <button mat-stroked-button color="primary" [disabled]="!procedureForm.valid" type="submit">Valider
              </button>
            }
            @if (currentEtat == EtatEnum.ARCHIVE) {
              <button mat-stroked-button color="warn" [disabled]="!procedureForm.valid"
                      (click)="$event.preventDefault();onSubmit(EtatEnum.EN_ATTENTE)">Mettre en attente d'activation
              </button>
              <button mat-stroked-button color="primary" [disabled]="!procedureForm.valid" type="submit">Valider
              </button>
            }
            @if (currentEtat == EtatEnum.EN_APPLICATION) {
              <button mat-stroked-button color="warn" [disabled]="!procedureForm.valid || !canUserModify()"
                      (click)="$event.preventDefault();onSubmit(EtatEnum.EN_APPLICATION)">Enregistrer
              </button>
              <button mat-stroked-button color="warn" [disabled]="!procedureForm.valid"
                      (click)="$event.preventDefault();onSubmit(EtatEnum.ARCHIVE)">Archiver
              </button>
            }
          }
        </div>
      }
    </form>
  </mat-card-content>
</mat-card>
